import { handleNonJsonResponseHandler } from '../selexp-api-base-query';
import { selexpConParApiDuck } from '../selexp-conpar-api-duck';

import { TParticipation } from './types-participation-details';
import { transformParticipationDetails } from './transformations-participation-details';

export const paticipantDetailsApiDuck = selexpConParApiDuck.injectEndpoints({
  endpoints: (builder) => ({
    getParticipantDetails: builder.query<TParticipation | undefined, string>({
      query: () => ({
        url: '/Participant/GetParticipantDetails',
        responseHandler: handleNonJsonResponseHandler,
        noFilters: true,
      }),
      transformResponse: transformParticipationDetails,
    }),
  }),
});

export const { useGetParticipantDetailsQuery } = paticipantDetailsApiDuck;
